<div class="loader-container">
  <img src="assets/media/images/logo/white-logo.png">
  <div class="spinner"></div>
  <h2>{{currentMessage}}</h2>
</div>
